import _ from 'lodash'
import React from 'react'
import colors from 'live/services/colors'
import { useTheme } from 'styled-components'
// import { useThemeContext } from '@intelie/ui'  //maybe it's the correct way, but it didn't switch the theme

const ReactPlotly = React.lazy(() => import('react-plotly.js'))

export const SuspededReactPlotly = props => {
    return (
        <React.Suspense fallback={null}>
            <ReactPlotly {...props} />
        </React.Suspense>
    )
}

export type WidgetProps = LiveReactChartProps<PlotlyState, PlotlyMessage, PlotlyWidgetConfig>

export function PlotlyWidget(props: WidgetProps): JSX.Element {
    const theme = useTheme()
    const { state: reducerState, widget } = props
    const plotlyConfig = reducerState.config
    const { jsonConfig = {} } = widget
    const { legendEnabled } = jsonConfig

    if (!plotlyConfig) {
        return <div />
    }

    return (
        <React.Suspense fallback={null}>
            <div className="live-plotly">
                <ReactPlotly
                    {...plotlyConfig}
                    responsive
                    useResizeHandler
                    layout={_.merge(
                        {
                            showlegend: legendEnabled,
                            // if showlegend:true, apply default as true if bottom selected, apply x:0,y:0 and orientation:h

                            autosize: true,
                            // SVG and div properties
                            margin: {
                                l: 0,
                                r: 0,
                                t: 0,
                                b: 0
                            },
                            paper_bgcolor: theme['gray-0'],
                            plot_bgcolor: theme['gray-0'],
                            yaxis: {
                                color: theme['gray-800'],
                                linecolor: theme['gray-800'],
                                linewidth: 1,
                                gridcolor: theme['gray-700'],
                                title: {
                                    font: {
                                        color: theme['gray-800']
                                    }
                                }
                            },
                            xaxis: {
                                color: theme['gray-800'],
                                linecolor: theme['gray-800'],
                                linewidth: 1,
                                gridcolor: theme['gray-500'],
                                title: {
                                    font: {
                                        color: theme['gray-800']
                                    }
                                }
                            },
                            colorway: colors.all,
                            legend: {
                                x: 0,
                                y: 0,
                                orientation: 'h',
                                font: {
                                    color: theme['gray-800']
                                }
                            },
                            scene: {
                                xaxis: {
                                    color: theme['gray-800'],
                                    spikecolor: theme['gray-800'],
                                    linecolor: theme['gray-800'],
                                    gridcolor: theme['gray-700'],
                                    title: {
                                        font: {
                                            color: theme['gray-800']
                                        }
                                    }
                                },
                                yaxis: {
                                    color: theme['gray-800'],
                                    spikecolor: theme['gray-800'],
                                    linecolor: theme['gray-800'],
                                    gridcolor: theme['gray-700'],
                                    title: {
                                        font: {
                                            color: theme['gray-800']
                                        }
                                    }
                                },
                                zaxis: {
                                    color: theme['gray-800'],
                                    spikecolor: theme['gray-800'],
                                    linecolor: theme['gray-800'],
                                    gridcolor: theme['gray-700'],
                                    title: {
                                        font: {
                                            color: theme['gray-800']
                                        }
                                    }
                                }
                            }
                        },
                        plotlyConfig?.layout ?? {}
                    )}
                />
            </div>
        </React.Suspense>
    )
}
